import { render, staticRenderFns } from "./ModalAccountDelete.vue?vue&type=template&id=5e6608de&scoped=true&"
import script from "./ModalAccountDelete.vue?vue&type=script&lang=ts&"
export * from "./ModalAccountDelete.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAccountDelete.vue?vue&type=style&index=0&id=5e6608de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6608de",
  null
  
)

export default component.exports